import React, { useCallback, useState } from 'react';
import { makeStyles, Button } from "../../../../index";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ImageEditor } from "./ImageEditor";
import { IconCropper } from "./IconCropper";
var useStyles = makeStyles(function () { return ({
    imageEditingArea: {
        position: 'relative',
    },
    rotateButton: {
        position: 'absolute',
        right: -160,
        bottom: 60,
    },
    changeButton: {
        position: 'absolute',
        right: -160,
        bottom: 4,
    },
}); });
export var ImageEditorContainer = function (_a) {
    var isIcon = _a.isIcon, editorMaxWidth = _a.editorMaxWidth, editorMaxHeight = _a.editorMaxHeight, imageDataUrl = _a.imageDataUrl, imageType = _a.imageType, changeButtonLabel = _a.changeButtonLabel, onChangeImageDataUrl = _a.onChangeImageDataUrl, onChangeButtonClick = _a.onChangeButtonClick, onErrorImageLoading = _a.onErrorImageLoading;
    var classes = useStyles();
    var t = useTranslation().t;
    var _b = useState(0), rotate = _b[0], setRotate = _b[1];
    var handleClickRotate = useCallback(function () {
        setRotate((rotate + 90) % 360);
    }, [rotate]);
    return (React.createElement("div", { className: classes.imageEditingArea },
        isIcon ? (React.createElement(IconCropper, { maxWidth: editorMaxWidth, maxHeight: editorMaxHeight, src: imageDataUrl, imageType: imageType, rotation: rotate, onCropped: onChangeImageDataUrl, onError: onErrorImageLoading })) : (React.createElement(ImageEditor, { maxWidth: editorMaxWidth, maxHeight: editorMaxHeight, src: imageDataUrl, imageType: imageType, rotation: rotate, onCropped: onChangeImageDataUrl, onError: onErrorImageLoading })),
        React.createElement(Button, { className: classes.rotateButton, variant: "square", onClick: handleClickRotate }, t('回転')),
        React.createElement(Button, { className: classes.changeButton, variant: "square", onClick: onChangeButtonClick }, changeButtonLabel)));
};
